import {createAction, createAsyncThunk} from '@reduxjs/toolkit'

import {DELIVERY_MEMO, DeliveryMemoType} from '@web/core/constants'
import {decodeHtmlEntities as decode} from '@web/helpers/htmlEntities'

import memoApi from './apis/memo'

/** 메모 셀렉트박스의 프리셋 리스트 조회 */
export const getPresetMemoList = createAsyncThunk('deliveryManager/getPresetMemoList', async () => {
    const {deliveryMemos} = await memoApi.getPresetMemoList()
    const presetMemos = deliveryMemos.map(({memo, memoSeq, template}) => {
        return {
            type: template ? DELIVERY_MEMO.COMMON : DELIVERY_MEMO.WRITTEN,
            value: decode(memo),
            removable: !template,
            memoSeq,
        }
    })

    const memoBook = [
        {
            type: DELIVERY_MEMO.NOTHING, // 선택안함
            value: '',
            removable: false,
            memoSeq: 0,
        },
        {
            type: DELIVERY_MEMO.WRITTEN, // 직접 입력하기
            value: '',
            removable: false,
            memoSeq: 0,
        },
        ...presetMemos,
    ]

    return memoBook
})

/** 배송 메모 수정 */
export const changeMemo = createAction<{
    value: string
    type: DeliveryMemoType
    productOrderNo?: string
}>('deliveryManager/changeMemo')

/** 개별 배송 메모 토글 */
export const toggleParticularMemo = createAction('deliveryManager/toggleParticularMemo')

/** 다음에도 사용할게요 토글 */
export const toggleSaveAsDefaultMemo = createAction('deliveryManager/toggleSaveAsDefaultMemo')

/** 프리셋 메모 중 커스텀프리셋메모 제거 */
export const deletePresetMemo = createAsyncThunk<number[], number[]>(
    'deliveryManager/deletePresetMemo',
    async (checkedMemoSeqs) => {
        await memoApi.deletePresetMemo({memoSeqs: checkedMemoSeqs})
        return checkedMemoSeqs
    },
)
